export const loanListStateEnum = Object.freeze({
    "EMPTY":                    1,
    "PENDING":                  2,
    "UNSUCCESSFULLY_LOADED":    3,
    "READY":                    4
});